module.exports = __webpack_public_path__ + "img/Multifinance Anak Bangsa.5bb50955.png";